import cn from 'classnames';
import styles from 'components/Shared/Icon/styles.scss';
import { IconProps } from 'components/Shared/Icon/index';

export const iconStyles = ({ className, size, appearance }: IconProps) =>
  cn(styles.base, className, {
    [styles.tiny]: size === 'tiny',
    [styles.small]: size === 'small',
    [styles.medium]: size === 'medium',
    [styles.large]: size === 'large',
    [styles.xl]: size === 'xl',
    [styles.xl2]: size === 'xl2',
    [styles.mega]: size === 'mega',
    [styles.flip45]: appearance === 'flip-45',
    [styles.flip90]: appearance === 'flip-90',
    [styles.flip180]: appearance === 'flip-180',
    [styles.flip270]: appearance === 'flip-270'
  });
